import Glide from '@glidejs/glide';

// This file contains global configuration that should be called on every page load.
document.addEventListener('alpine:init', () => {
    // Header navigation
    Alpine.data('navData', () => ({
        showMenu: false,
        active: [],
        main: null,
        footer: null,
        init() {
            this.main = document.querySelector("main");
            this.footer = document.querySelector("footer");
        },
        openMenu() {
            this.showMenu = true;
            if (window.innerWidth < 1024) {
                this.main.classList.add("hidden");
                this.footer.classList.add("hidden");
            }
        },
        closeMenu() {
            this.showMenu = false;
            if (window.innerWidth < 1024) {
                this.main.classList.remove("hidden");
                this.footer.classList.remove("hidden");
            }
        },
        openSubMenu(id) {
            this.active.push(id);
        },
        closeSubMenu(id) {
            const index = this.active.indexOf(id);
            this.active.splice(index, 1);
        },
        showSubMenu(id) {
            return this.active.includes(id);
        }
    }))
});

if (document.querySelectorAll('.glide') !== null) {

    var sliders = document.querySelectorAll('.glide');

    for (var i = 0; i < sliders.length; i++) {
        var glide = new Glide(sliders[i], {
            type: 'slider',
            perView: 3,
            breakpoints: {
                1024: {
                    perView: 1
                }
            },
            autoplay: 2000,
            gap: 100
        });

        glide.mount();
    }
}